import * as Sentry from '@sentry/react';
import sportsApi from '../../utils/sportsApi';

const censusSSOlogin = store => async state => {
    try {
        const response = await sportsApi
            .url('/census/sso')
            .options({ credentials: 'include' })
            .get()
            .json();
        store.setState({
            user: {
                ...state.user,
                censusJWT: response.JWT,
            },
        });

        Sentry.addBreadcrumb({
            category: 'API',
            message: 'Census SSO login success',
        });

        return true;
    } catch (e) {
        Sentry.addBreadcrumb({
            category: 'API',
            message: 'Census SSO login error: ' + e.message,
        });
        throw e;
    }
};

export default censusSSOlogin;
